module.exports = __webpack_public_path__ + "img/coldHotWind.c0b05b6d.svg";